@use '@ingka/variables/style.scss' as *;

.loyaltyButton {
  display: flex;
  align-items: end;
  padding: $space-25;
  outline: none;
  border: none;
  border-radius: $radius-s;
}

.loyaltyButton:hover {
  cursor: pointer;
}

.loyaltyButton:focus, .loyaltyButton:focus-within {
  outline: none;
  box-shadow: inset 0 0 0 2px $colour-interactive-subtle-border-selected;
}
